import * as React from 'react'
import styles from './index.module.scss'
import clsx from 'clsx'
import { SxProps, sx as sxFunc, spacing } from '../sx'
export interface ContainerProps {
  Component?: React.ElementType
  className?: string
  disableGutters?: boolean
  children: React.ReactNode
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx?: SxProps
}
export const Container = React.forwardRef<HTMLDivElement, ContainerProps>(
  (props, ref) => {
    const {
      Component = 'div',
      className,
      disableGutters = false,
      children,
      sx,
      ...other
    } = props
    return (
      <Component
        ref={ref}
        className={clsx(
          styles.root,
          disableGutters && spacing({ px: 0 }),
          className,
          sxFunc(sx)
        )}
        {...other}
      >
        {children}
      </Component>
    )
  }
)
Container.displayName = 'Container'
